import React from 'react';
import { Share as Sharebuttons } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import './style.scss';

const Share = (props) => {
  const {
    title = null,
    pageTitle,
    items = [
      'facebook',
      'twitter',
      'linkedin',
      'whatsapp',
      'mail',
    ],
  } = props;

  const { t } = useTranslation();

  return (
    <div>
      <Sharebuttons
        title={(title || t('share'))}
        items={items}
        pageTitle={title}
        url={window.location.href}
      />
    </div>
  );
};

export default Share;
